<template>
  <b-card :class="'main'">
      <h1>{{ $t("pages.my_projects.title") }}</h1>
      <p>{{ $t("pages.my_projects.body") }}</p>
      <ProjectsTable />

      <b-modal id="payment-confirm-success" :title="$t('pages.payment_confirmation.title_success')" ok-only :ok-title="$t('pages.payment_confirmation.actionbtn_label')">
        <div class="d-block text-center">
          <b-icon icon="check-circle" scale="6" variant="success" class="m-5" />
          <p>{{ $t('pages.payment_confirmation.body_success') }}</p>
        </div>
      </b-modal>

      <b-modal id="payment-confirm-failed" :title="$t('pages.payment_confirmation.title_failed')" ok-only :ok-title="$t('buttons.close')">
        <div class="d-block text-center">
          <p>{{ $t('pages.payment_confirmation.body_failed') }}</p>
        </div>
      </b-modal>
  </b-card>
</template>
<script>
import ProjectsTable from "@/components/ProjectsTable.vue";
import store from '../store/store';

export default {
  components: {
    ProjectsTable,
  },
  mounted() {
    if (this.$route.params.payment_confirm) {
      if (this.$route.params.payment_confirm === 'success') {
        this.$bvModal.show('payment-confirm-success');
        this.$store.dispatch('getUser');
      }
      else {
        this.$bvModal.show('payment-confirm-failed');
      }
    }
  },
  metaInfo() {
    return {
      title: this.$t("pages.my_projects.title")
    }
  }
};
</script>
